import React from 'react';

import ModalOne from './ModalOne';
import ModalTwo from './ModalTwo';
import ModalThree from './ModalThree';

const ModalManager = ({ closeFn, modal = '' }) => {
  return (
    <>
      <ModalOne closeFn={closeFn} open={modal === 'modal-one'} />
      <ModalTwo closeFn={closeFn} open={modal === 'modal-two'} />
      <ModalThree closeFn={closeFn} open={modal === 'modal-three'} />
    </>
  );
};

export default ModalManager;